import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Convierte una ruta relativa de imagen ("/static/...") en URL absoluta.
export const mediaUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  // Los estáticos se sirven bajo /api para pasar por el ingress.
  return `${BACKEND_URL}/api${path}`;
};

// Clasifica el error de una consulta pública para mostrar el mensaje correcto:
// - "servicio": sin respuesta o 5xx → el servicio falló, no es que la unidad no exista.
// - "limite": 429 → el buscador (o el login) tiene rate limiting; nunca es "no existe".
// - "invalido": 400/422 → el término de búsqueda no es válido (p. ej. demasiado largo).
// - "no-encontrado": cualquier otro 4xx (típicamente 404) → esa unidad no existe.
export const clasificarError = (err) => {
  const status = err?.response?.status;
  if (!status || status >= 500) return "servicio";
  if (status === 429) return "limite";
  if (status === 400 || status === 422) return "invalido";
  return "no-encontrado";
};

export const mensajeError = (err, fallback) => err?.response?.data?.detail || fallback;

export const api = axios.create({ baseURL: API });

export const buscarUnidad = (q) =>
  api.get(`/buscar`, { params: { q } }).then((r) => r.data);

export const obtenerUnidad = (vin) =>
  api.get(`/unidad/${encodeURIComponent(vin)}`).then((r) => r.data);

export const MAX_VIDEO_BYTES = 50 * 1024 * 1024;
export const EXT_VIDEO = ["mp4", "mov", "webm"];

export const obtenerEnlace = (token) =>
  api.get(`/enlace/${encodeURIComponent(token)}`).then((r) => r.data);

// Subida con progreso y cancelación: devuelve { promesa, cancelar }. El archivo viaja como
// cuerpo crudo (sin multipart) y la clave de idempotencia evita duplicados al reintentar.
export const subirVideoEnlace = (token, archivo, clave, onProgreso) => {
  const xhr = new XMLHttpRequest();
  const promesa = new Promise((resolve, reject) => {
    xhr.open("POST", `${API}/enlace/${encodeURIComponent(token)}/videos?nombre=${encodeURIComponent(archivo.name)}`);
    xhr.setRequestHeader("Idempotency-Key", clave);
    xhr.upload.onprogress = (e) => e.lengthComputable && onProgreso(Math.round((e.loaded / e.total) * 100));
    xhr.onload = () => {
      let cuerpo = null;
      try { cuerpo = JSON.parse(xhr.responseText); } catch { /* respuesta sin JSON */ }
      if (xhr.status >= 200 && xhr.status < 300) resolve(cuerpo);
      else reject({ status: xhr.status, detalle: typeof cuerpo?.detail === "string" ? cuerpo.detail : null });
    };
    xhr.onerror = () => reject({ status: 0, detalle: null });
    xhr.onabort = () => reject({ status: -1, detalle: null });
    xhr.send(archivo);
  });
  return { promesa, cancelar: () => xhr.abort() };
};
